/**
 * This method returns index of number lowest closest to target in array
 * Array must be sorted in ascending order
 * e.g. array = [1, 2, 6, 7], target = 5, then it will return 2
 */
export const findIndexOfLowestClosestNumber = (array: number[], target: number) => {
  let minDiff = Number.MAX_VALUE;
  if (array.length === 0) {
    return -1;
  }
  let minDiffIndex = 0;
  for (let i = 0; i < array.length; i++) {
    const item = array[i];
    if (item === target) {
      return i;
    }

    if (item > target) {
      break;
    }
    const diff = Math.abs(item - target);
    if (diff < minDiff) {
      minDiff = diff;
      minDiffIndex = i;
    }
  }
  return minDiffIndex;
};
